<div class="search-container">
  <div class="search-header">
    <h1>{{ 'Search Results' | translate }}</h1>
    <p *ngIf="keyword" class="search-query">{{ 'Searching for' | translate }}: <strong>{{ keyword }}</strong></p>
  </div>

  <div class="search-content">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
      <div class="spinner"></div>
      <p>{{ 'Searching' | translate }}...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <i class="bi bi-exclamation-circle"></i>
      <p>{{ error }}</p>
    </div>

    <!-- Results List -->
    <div *ngIf="!loading && results.length > 0" class="results-wrapper">
      <div class="results-count">
        {{ 'Found' | translate }} <strong>{{ totalElements }}</strong> {{ 'results' | translate }}
      </div>

      <div class="results-list">
        <div
          *ngFor="let result of results"
          class="result-item"
          (click)="selectResult(result)"
        >
          <div class="result-icon result-avatar">
            <img *ngIf="getResultImage(result); else fallbackAvatar" [src]="getResultImage(result)" [alt]="getResultTitle(result)" />
            <ng-template #fallbackAvatar>
              <span>{{ getResultAvatarLabel(result) }}</span>
            </ng-template>
          </div>
          <div class="result-content">
            <h3 class="result-title">
              {{ getResultTitle(result) }}
            </h3>
            <div class="result-meta">
              <span class="result-type">{{ getResultSubtitle(result) }}</span>
              <span *ngIf="result.department" class="result-department">{{ result.department }}</span>
              <span *ngIf="result.category" class="result-category">{{ result.category }}</span>
            </div>
            <p *ngIf="getResultDescription(result)" class="result-description">
              {{ getResultDescription(result) | slice : 0 : 100 }}{{ hasLongDescription(result) ? '...' : '' }}
            </p>
          </div>
          <div class="result-arrow">
            <i class="bi bi-chevron-right"></i>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div *ngIf="getTotalPages() > 1" class="pagination">
        <button
          [disabled]="currentPage === 0"
          (click)="onPageChange(currentPage - 1)"
          class="pagination-btn"
        >
          {{ 'Previous' | translate }}
        </button>

        <div class="pagination-info">
          {{ currentPage + 1 }} / {{ getTotalPages() }}
        </div>

        <button
          [disabled]="currentPage >= getTotalPages() - 1"
          (click)="onPageChange(currentPage + 1)"
          class="pagination-btn"
        >
          {{ 'Next' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
